import styled from 'styled-components'

export const StyledContainer = styled.div`
  position: relative;
`

export const StyleListItem = styled.li`
  margin-bottom: 16px;
`
